import { Editor, Node, Path, Text, Transforms } from 'slate';
import EditorUtils from '../../../AhaEditorUtils/EditorUtils';
import { ReactEditor } from 'slate-react';
import type { EventHandlerParams } from './types';

const handleArrowUp = ({
  editor,
  event,
  currentBlock,
  isVoid,
}: EventHandlerParams) => {
  if (!isVoid) {
    if (Path.equals(currentBlock[1], [0])) return;
    if (!Path.hasPrevious(currentBlock[1])) return;

    const previousPath = Path.previous(currentBlock[1]);
    const previousNode = Node.get(editor, previousPath);
    const siblingIsVoid =
      !Editor.isEditor(previousNode) &&
      !Text.isText(previousNode) &&
      Editor.isVoid(editor, previousNode);

    if (!siblingIsVoid) return;
  }

  if (Path.equals(currentBlock[1], [0])) {
    Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
      at: currentBlock[1],
    });
    Transforms.select(editor, Editor.point(editor, currentBlock[1]));
  } else {
    const targetPath = Path.previous(currentBlock[1]);
    Transforms.select(editor, Editor.point(editor, targetPath));
  }

  event.preventDefault();
  ReactEditor.focus(editor);
  return true;
};

export default handleArrowUp;
